module.exports = __webpack_public_path__ + "assets/img/scan.dfddaf7b.svg";